import { CATEGORY_FILTER_INDICATOR } from '~~/constants/typesense';
import { getBreadcrumbsFromProduct } from '~~/helpers/category/getBreadcrumbsFromProduct';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export function getCategoriesStringFromProduct(product: ProductVariantExtended): string {

  const breadcrumbs = getBreadcrumbsFromProduct(product);
  const categoryNames = breadcrumbs.slice(1).map(breadcrumb => breadcrumb.name);

  return categoryNames.join(CATEGORY_FILTER_INDICATOR);

}
